import adminHttp from "@/api/adminHttp";

const END_POINT = '/api/admin/tournament-template';

export default {
    index: (params) => adminHttp.get(END_POINT, { params }),
    show: (id) => adminHttp.get(`${END_POINT}/${id}`),
    store: (data) => adminHttp.post(END_POINT, data),
    update: (id, data) => adminHttp.put(`${END_POINT}/${id}`, data),
    delete: (id) => adminHttp.delete(`${END_POINT}/${id}`),
}
